import { useState, type FormEvent } from 'react';
import { api } from '../../api';
import { NOME_PAPEL_CONTATO, telefone, tiposDe } from '../../componentes/formatos';

export interface DadosContato { id?: string; nome: string; papel: string; local_id: string | null; telefone: string | null; email: string | null; recebe_os: boolean; ativo: boolean; versao?: number }

export function FormContato({ clienteId, locais, inicial, aoSalvar, aoCancelar }: {
  clienteId: string; locais: { id: string; nome: string }[]; inicial?: DadosContato; aoSalvar: () => void; aoCancelar: () => void;
}) {
  const [f, setF] = useState<DadosContato>(inicial ? { ...inicial, telefone: inicial.telefone ? telefone(inicial.telefone) : '' } : { nome: '', papel: 'sindico', local_id: null, telefone: '', email: '', recebe_os: false, ativo: true });
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  const set = (k: keyof DadosContato) => (e: { target: { value: string } }) => setF({ ...f, [k]: e.target.value });

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null); setSalvando(true);
    const corpo = { nome: f.nome, papel: f.papel, local_id: f.local_id || null, telefone: f.telefone || null, email: f.email || null, recebe_os: f.recebe_os, ativo: f.ativo };
    try {
      if (inicial?.id) await api(`/contatos/${inicial.id}`, { metodo: 'PATCH', corpo: { ...corpo, versao: inicial.versao } });
      else await api(`/clientes/${clienteId}/contatos`, { metodo: 'POST', corpo });
      aoSalvar();
    } catch (err) { setErro(err instanceof Error ? err.message : 'Não foi possível salvar.'); }
    finally { setSalvando(false); }
  }

  return (
    <form className="form" onSubmit={enviar}>
      <div className="linha-2">
        <label>Nome<input required minLength={2} maxLength={160} value={f.nome} onChange={set('nome')} autoFocus /></label>
        <label>Papel
          <select value={f.papel} onChange={set('papel')}>{tiposDe(NOME_PAPEL_CONTATO).map(([v, r]) => <option key={v} value={v}>{r}</option>)}</select>
        </label>
      </div>
      <div className="linha-2">
        <label>Telefone / WhatsApp<input value={f.telefone ?? ''} onChange={set('telefone')} inputMode="tel" placeholder="(19) 99999-9999" /></label>
        <label>E-mail<input type="email" maxLength={200} value={f.email ?? ''} onChange={set('email')} /></label>
      </div>
      {locais.length > 0 && (
        <label>Parque (opcional)
          <select value={f.local_id ?? ''} onChange={(e) => setF({ ...f, local_id: e.target.value || null })}>
            <option value="">Todos os parques do cliente</option>
            {locais.map((l) => <option key={l.id} value={l.id}>{l.nome}</option>)}
          </select>
        </label>
      )}
      <label className="check"><input type="checkbox" checked={f.recebe_os} onChange={(e) => setF({ ...f, recebe_os: e.target.checked })} /> Recebe o aviso de OS concluída</label>
      {inicial?.id && <label className="check"><input type="checkbox" checked={f.ativo} onChange={(e) => setF({ ...f, ativo: e.target.checked })} /> Contato ativo</label>}
      {erro && <p className="alerta" role="alert">{erro}</p>}
      <div className="acoes-form">
        <button type="button" className="btn-fantasma" onClick={aoCancelar}>Cancelar</button>
        <button className="btn" disabled={salvando || f.nome.trim().length < 2}>{salvando ? 'Salvando…' : 'Salvar'}</button>
      </div>
    </form>
  );
}
